export enum TabEnum {
    Absolute = 'absolute',
    Percentage = 'percentage',
}
